export default {
  id: "creators",
  name: "Creator Hub",
  shortName: "Creators",
  description: "Content creator submissions & management",
  icon: "users",
  color: "#8B5CF6",
  roles: ["super_admin", "admin", "corporate"],
  css: "styles/apps/creators.css?v=4",
  nav: [
    { id: "submissions", label: "Submissions" },
    { id: "creators", label: "Creators" },
  ],
  defaultView: "submissions",
};
